import React, { useRef, useEffect, useContext } from 'react'
import { AppContext, DispatchContext } from "../AppContext";


export default function CanvasCompare(props) {

    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const canvasRef = useRef(null);

    useEffect(() => {

        // https://stackoverflow.com/questions/43663279/html-canvas-javascript-hover-and-click-events
        if (!state.sourceMarkup)
            return;

        var length1 = state.sourceMarkup.Text1.Length;
        var length2 = state.sourceMarkup.Text2.Length;
        var maxLength = Math.max(length1, length2);

        var width = 900;
        var textPadding = 5;
        var barPadding = 10;
        var scale = width/maxLength;
        var y1 = 80;
        var y2 = 10;
        var height = 25;
        var emptyColor = "#EEEEEE";
        var borderColor = "#BBBBBB";
        var textColor = "#111111";

        const canvas = canvasRef.current;
        var ctx = canvas.getContext('2d');
        ctx.translate(0.5, 0.5);    // canvas pixel raster starts at 0.5, this fixes unsharp lines

        // reformat text markup into phrases 
        var positions = {};
        {state.sourceMarkup && state.sourceMarkup.Positions &&
            state.sourceMarkup.Text1.Markup.filter((source) => (source.PIdx != null)).map((source) => {
                positions[source.PIdx] = {
                    start1: source.Start * scale,
                    end1: source.End * scale
                };
            });
        }
        {state.sourceMarkup && state.sourceMarkup.Positions &&
            state.sourceMarkup.Text2.Markup.filter((source) => (source.PIdx != null)).map((source) => {
                positions[source.PIdx] = {
                    ...positions[source.PIdx],
                    start2: source.Start * scale,
                    end2: source.End * scale
                }
            });
        }

        // shift upper or lower bar to bring corresponding positions close together (take average of all translations)
        var shift = 0;
        {positions && 
            Object.keys(positions).map((key) => {
            var pos = positions[key];
            shift += (pos.start2 - pos.start1);
           });
        }
        shift /= Object.keys(positions).length;
        // decide which bar to shift 
        var shift1 = barPadding + ((shift > 0) ? shift : 0);
        var shift2 = barPadding + ((shift < 0) ? -shift : 0);
        // limit shift to prevent shifting out of bounds
        shift1 = Math.min(shift1, width + barPadding - (length1 * scale));
        shift2 = Math.min(shift2, width + barPadding - (length2 * scale));

        

        // draw beackground
        ctx.fillStyle = emptyColor;
        ctx.shadowColor = 'gray';
        ctx.shadowBlur = 10;
        ctx.fillRect(shift1, y1, length1 * scale, height);
        ctx.fillRect(shift2, y2, length2 * scale, height);

        // draw markup rects and bezier lines between them
        ctx.shadowBlur = 1;
        var bezierOffset = 25;
        var gap = 2;
        {positions && Object.keys(positions).map((key, idx) => {
            var pos = positions[key];
            var color = state.ui.colors[key % 10];
            ctx.fillStyle = color;
            ctx.strokeStyle = color;

            var width1 = Math.max(1.0, pos.end1 - positions[key].start1);
            ctx.fillRect(shift1 + pos.start1, y1, width1, height);
            var width2 = Math.max(1.0, pos.end2 - positions[key].start2);
            ctx.fillRect(shift2 + pos.start2, y2, width2, height);

            ctx.beginPath();
            ctx.moveTo(shift1 + pos.start1, y1 - gap);
            ctx.bezierCurveTo(shift1 + pos.start1, y1 - bezierOffset, shift2 + pos.start2, y2 + height + bezierOffset, shift2 + pos.start2, y2 + height + gap);
            ctx.lineTo(shift2 + pos.end2, y2 + height +gap)
            ctx.bezierCurveTo(shift2 + pos.end2, y2 + height + bezierOffset, shift1 + pos.end1, y1 - bezierOffset, shift1 + pos.end1, y1 - gap);
            ctx.closePath();
            ctx.stroke();
            ctx.fill();
        });}

        // add frame around bars
        ctx.strokeStyle = borderColor;
        ctx.shadowBlur = 0;
        ctx.rect(shift1, y1, length1 * scale, height);
        ctx.rect(shift2, y2, length2 * scale, height);
        ctx.stroke();

        // add descriptions
        ctx.shadowBlur = 0;
        ctx.fillStyle = textColor;
        ctx.font = '14px Roboto, Helvetica, Arial, sans-serif';
        var text1Overflow = Math.max(0, shift1 + textPadding + ctx.measureText(state.sourceMarkup.Text1.Name).width - width);
        var text2Overflow = Math.max(0, shift2 + textPadding + ctx.measureText(state.sourceMarkup.Text2.Name).width - width);
        ctx.fillText(state.sourceMarkup.Text1.Name, textPadding + shift1 - text1Overflow, y1 + 17);
        ctx.fillText(state.sourceMarkup.Text2.Name, textPadding + shift2 - text2Overflow, y2 + 17);

    }, []);

    return <canvas ref={canvasRef} {...props} />
}


